import React from "react";
import { CoursewareListItem } from "API/courseware";

interface CoursewareContextProps {
    current?: string;
    list: CoursewareListItem[];
    onSelect: (current: string) => void;
    markDone: (id: string) => void;
    downloadCourseware: (id: string) => void;
}

const CoursewareContext = React.createContext<CoursewareContextProps>({
    current: undefined,
    list: [],
    onSelect: () => null,
    markDone: () => null,
    downloadCourseware: () => null
});

export default CoursewareContext;
